module.exports = __webpack_public_path__ + "e62b6e9be07807aa04269bd123a45bcd.svg";